import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <a href="/" className="flex items-center flex-shrink-0">
              <img
                src="https://public.readdy.ai/ai/img_res/156395ee-9c05-4e2d-9b8e-de51476e9fd3.png"
                alt="Bridgend Electricians"
                className="h-14 w-auto"
              />
            </a>

            <div className="hidden lg:flex items-center space-x-8">
              <button
                onClick={() => scrollToSection('hero')}
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-secondary hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-secondary hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('gallery')}
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-secondary hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                Gallery
              </button>
              <button
                onClick={() => scrollToSection('reviews')}
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-secondary hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                Reviews
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-secondary hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                Contact
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-secondary hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                About
              </button>
            </div>

            <div className="hidden lg:flex items-center">
              <a
                href="tel:01656497474"
                className="bg-primary hover:bg-primary-dark text-white font-bold px-6 py-3 rounded-lg text-sm transition-all duration-300 hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                01656 497474
              </a>
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-3 rounded-lg cursor-pointer"
              aria-label="Toggle menu"
            >
              <div className="w-6 h-5 flex flex-col justify-between">
                <span
                  className={`block h-0.5 w-full transition-all duration-300 ${
                    isScrolled ? 'bg-secondary' : 'bg-white'
                  } ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}
                ></span>
                <span
                  className={`block h-0.5 w-full transition-all duration-300 ${
                    isScrolled ? 'bg-secondary' : 'bg-white'
                  } ${isMobileMenuOpen ? 'opacity-0' : ''}`}
                ></span>
                <span
                  className={`block h-0.5 w-full transition-all duration-300 ${
                    isScrolled ? 'bg-secondary' : 'bg-white'
                  } ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}
                ></span>
              </div>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
            <div className="px-4 py-6 space-y-4">
              <button
                onClick={() => scrollToSection('hero')}
                className="block w-full text-left text-secondary hover:text-primary font-semibold py-2 cursor-pointer"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="block w-full text-left text-secondary hover:text-primary font-semibold py-2 cursor-pointer"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('gallery')}
                className="block w-full text-left text-secondary hover:text-primary font-semibold py-2 cursor-pointer"
              >
                Gallery
              </button>
              <button
                onClick={() => scrollToSection('reviews')}
                className="block w-full text-left text-secondary hover:text-primary font-semibold py-2 cursor-pointer"
              >
                Reviews
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block w-full text-left text-secondary hover:text-primary font-semibold py-2 cursor-pointer"
              >
                Contact
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block w-full text-left text-secondary hover:text-primary font-semibold py-2 cursor-pointer"
              >
                About
              </button>
              <a
                href="tel:01656497474"
                className="block w-full bg-primary hover:bg-primary-dark text-white font-bold px-6 py-3 rounded-lg text-center transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                Call Now
              </a>
            </div>
          </div>
        )}
      </nav>

      <a
        href="tel:01656497474"
        className="fixed bottom-6 right-6 lg:hidden z-50 w-16 h-16 flex items-center justify-center bg-primary hover:bg-primary-dark text-white rounded-full shadow-2xl cursor-pointer animate-pulse-glow"
        aria-label="Call Now"
      >
        <i className="ri-phone-fill text-2xl"></i>
      </a>
    </>
  );
}
